/* eslint-disable import/no-unresolved */
import { Thermostat, WaterDropOutlined, ElectricBolt } from '@mui/icons-material';
import Iconify from 'src/components/iconify/Iconify';
import { Box } from '@mui/material';

const SENSOR_ICONS = {
  tempI: (props) => <Thermostat {...props} fontSize="" />,
  tempP1: (props) => <Iconify {...props} icon="mdi:thermometer-probe" />,
  // Probe 2 is the same instrument as probe 1, so it carries the same glyph with a numeral rather
  // than a different picture. An asset card shows both probes side by side and the only question a
  // reader has there is which is which; two unrelated icons would answer a question nobody asked and
  // leave that one open. dfrO2 below numbers itself the same way.
  tempP2: ({ width = 24, sx, ...props }) => (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        width,
        height: width,
        flexShrink: 0,
        verticalAlign: '-0.125em',
        ...sx,
      }}
    >
      <Iconify {...props} icon="mdi:thermometer-probe" width={width} />
      <Box
        component="span"
        sx={{
          position: 'absolute',
          right: width * -0.08,
          bottom: width * -0.04,
          fontSize: width * 0.52,
          fontWeight: 800,
          lineHeight: 1,
          // currentColor, so the numeral tracks the glyph wherever this lands — the card header is
          // tinted and the asset view is not, and a fixed colour is only ever right on one of them.
          color: 'currentColor',
          // The glyph's stem runs up the left, so the numeral sits bottom-right where it is clear of
          // it. The tint behind keeps it legible if a future layout puts the two closer together.
          textShadow: '0 0 2px rgba(255,255,255,0.9)',
          pointerEvents: 'none',
        }}
      >
        2
      </Box>
    </Box>
  ),
  humidI: (props) => <WaterDropOutlined {...props} fontSize="" />,
  dfrO2: ({ width = 24, sx, ...props }) => (
    <Box
      component="svg"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      sx={{
        width, height: width, verticalAlign: '-0.125em', flexShrink: 0, ...sx,
      }}
    >
      <circle cx="6.4" cy="5.1" r="2.2" />
      <circle cx="11.3" cy="2.7" r="1.15" />
      <circle cx="8.7" cy="14" r="5.2" />
      <text x="13.9" y="21.6" fontSize="12" fontWeight="800" fill="currentColor" stroke="none" fontFamily="ui-sans-serif, system-ui, Arial, sans-serif">2</text>
    </Box>
  ),
  pressure: (props) => <Iconify {...props} icon="ix:gauge" />,
  lid: (props) => <Iconify {...props} icon="system-uicons:box-open" />,
  imu: (props) => <ElectricBolt {...props} fontSize="" />,
  als: (props) => <Iconify {...props} icon="lets-icons:sun-light" />,
  carContainer: (props) => <Iconify {...props} icon="ph:shipping-container-duotone" />,
  carSeat: (props) => <Iconify {...props} icon="mdi:steering" />,
  // SEN66 air-quality module. The four particulate sizes share one icon -- they are the
  // same measurement at different cut-offs, and four distinct glyphs would read as four
  // unrelated sensors.
  sen66Pm: (props) => <Iconify {...props} icon="mdi:blur" />,
  sen66CO2: (props) => <Iconify {...props} icon="mdi:molecule-co2" />,
  sen66VOC: (props) => <Iconify {...props} icon="mdi:air-filter" />,
  sen66NOx: (props) => <Iconify {...props} icon="mdi:smog" />,
  sen66AQI: (props) => <Iconify {...props} icon="mdi:air-purifier" />,
};

export default SENSOR_ICONS;
